import { BaseRuleInstance } from '@jupiterone/jupiter-types';
import { QuestionRuleInstanceWithTags } from '@jupiterone/jupiter-web-toolkit';

export const nameIsNotEmpty = (value: string) => ({
  error: value.length === 0,
  helpText: value.length === 0 ? 'Name cannot be empty' : '',
});

export const hasNoEmptyTemplateFields = (
  templates: BaseRuleInstance['templates']
) => {
  let error = false;
  if (templates) {
    Object.keys(templates).forEach((k: string) => {
      if (!k.length || !templates[k].length) {
        error = true;
      }
    });
  }
  return {
    error,
    helpText: error ? 'All template fields must be filled in' : '',
  };
};

export const checkBeforeSubmitting = (
  rule: Partial<QuestionRuleInstanceWithTags>
) => {
  const errors = [
    nameIsNotEmpty(rule.name || ''),
    hasNoEmptyTemplateFields(rule.templates),
  ];
  return errors.filter((e) => e.error);
};
